// extracted by mini-css-extract-plugin
var _1 = "NotificationItem-module__animateUploadProgressBarWidth--bKoM7";
var _2 = "NotificationItem-module__animatedBackground--k_fUV";
var _3 = "NotificationItem-module__avatarContainer--p9wUM";
var _4 = "NotificationItem-module__container--utLF_";
var _5 = "NotificationItem-module__dot--m5hia";
var _6 = "NotificationItem-module__dotContainer--IBh72";
var _7 = "NotificationItem-module__mainContent--Nb97K";
var _8 = "NotificationItem-module__notificationItem--_FweV";
var _9 = "NotificationItem-module__readControl--fKsoN";
var _a = "NotificationItem-module__text--MU1i6";
var _b = "NotificationItem-module__timestamp--QmuNf";
var _c = "NotificationItem-module__unread--EnPH9";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarContainer", _4 as "container", _5 as "dot", _6 as "dotContainer", _7 as "mainContent", _8 as "notificationItem", _9 as "readControl", _a as "text", _b as "timestamp", _c as "unread" }
